import React from 'react';
import StatsCard from './StatsCard';

/**
 * Grid layout for displaying multiple StatsCard components
 * Automatically handles responsive layout
 * 
 * Supports two usage patterns:
 * 1. Pass stats array: <StatsGrid stats={[{title, value, ...}]} />
 * 2. Pass children: <StatsGrid><StatsCard .../><StatsCard .../></StatsGrid>
 * 
 * @param {Array} stats - Array of stat configurations (optional)
 * @param {number} columns - Number of columns (2, 3, 4, 5)
 * @param {React.ReactNode} children - StatsCard components as children (optional)
 */
export default function StatsGrid({ stats = [], columns = 4, className = '', children }) {
  // Responsive column classes
  const columnClasses = {
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-2 sm:grid-cols-2 lg:grid-cols-4',
    5: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-5'
  };
  
  // If children are provided, render them directly
  // Otherwise, render from stats array
  const hasChildren = React.Children.count(children) > 0;
  
  return (
    <div className={`grid ${columnClasses[columns] || columnClasses[4]} gap-4 ${className}`}>
      {hasChildren ? children : stats.map((stat, index) => (
        <StatsCard
          key={stat.id || index}
          title={stat.title}
          value={stat.value}
          prefix={stat.prefix}
          suffix={stat.suffix}
          icon={stat.icon}
          iconBgColor={stat.iconBgColor}
          iconColor={stat.iconColor}
          valueColor={stat.valueColor}
          trend={stat.trend}
          trendLabel={stat.trendLabel}
          description={stat.description}
          onClick={stat.onClick}
          testId={stat.testId}
        />
      ))}
    </div>
  );
}
